<button *ngIf="!hide1" type="button" class="btn btn-primary btn-primary--sm margin-right-10" (click)="onAction1()">{{ label1 }}</button>
<a *ngIf="!hide2" class="cursor-pointer eod-text-primary" (click)="onAction2()">{{ label2 }}</a>
